/**
 * @generated SignedSource<<1c87b16fb3b8fe581e35592d76f378c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TitleColumn_TreeNodeFragment$data = {
  readonly structureDefinition: {
    readonly icon?: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title?: string;
  };
  readonly " $fragmentType": "TitleColumn_TreeNodeFragment";
};
export type TitleColumn_TreeNodeFragment$key = {
  readonly " $data"?: TitleColumn_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TitleColumn_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleColumn_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "icon",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "10027f2e84daf7cf38786ca9df94a8fa";

export default node;
